import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "input"]

  update(event) {
    event.preventDefault()
    const status = event.target.dataset.status
    this.inputTarget.value = status
    this.formTarget.requestSubmit()
  }
} 